/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */

import React, { useEffect } from 'react';

import { Container, Grid, makeStyles, Typography } from '@material-ui/core';

import IconClose from '../../assets/images/ic-close-round.svg';
import LoadingButton from '../common/LoadingButton';

const useStyles = makeStyles((theme) => {
  return {
    container: {
      display: 'block',
      margin: '0px',
      padding: '20px',
      width: 'auto',
      [theme.breakpoints.up('lg')]: {
        padding: '30px 36px 50px',
        width: '586px',
      },
    },
    containerButton: {
      margin: 'auto',
      width: '100%',
      [theme.breakpoints.up('lg')]: {
        width: '196px',
      },
    },
    containerDescription: {
      margin: '0px 0px 30px',
      textAlign: 'center',
    },
    iconClose: {
      cursor: 'pointer',
      height: '24px',
      width: '24px',
    },
    typographyDescription: {
      color: '#999999',
      fontSize: '12px',
      lineHeight: '18px',
      margin: '0px auto',
      maxWidth: '373px',
      textAlign: 'center',
    },
    typographySubtitle: {
      color: '#172B4D',
      fontSize: '16px',
      fontWeight: 600,
      lineHeight: '24px',
      marginBottom: '5px',
      textAlign: 'center',
    },
    typographyTitle: {
      color: theme.palette.primary.main,
      fontSize: '22px',
      fontWeight: 600,
      marginBottom: '20px',
      marginTop: '11px',
      textAlign: 'center',
      [theme.breakpoints.up('lg')]: {
        fontSize: '22px',
        marginBottom: '25px',
        marginTop: '22px',
      },
    },
  };
});

export default ({ onStartProductDemo, onCrossIconClick }) => {
  const classes = useStyles();

  useEffect(() => {
    return () => {};
  }, []);

  const handleClose = () => {
    if (onCrossIconClick) onCrossIconClick();
  };

  const handleStartProductDemo = () => {
    if (onStartProductDemo) onStartProductDemo();
  };

  return (
    <Container disableGutters className={classes.container}>
      <Grid container justify="flex-end">
        <Grid item style={{ lineHeight: '0px' }}>
          <img onClick={handleClose} src={IconClose} className={classes.iconClose} alt="Close Icon" />
        </Grid>
      </Grid>

      <Typography className={classes.typographyTitle}>Welcome to Mediphany</Typography>
      <Typography className={classes.typographySubtitle}>Thank you for registering!</Typography>

      <div className={classes.containerDescription}>
        <Typography className={classes.typographyDescription}>
          This is a quick tour of the layout of your Personal Medical Record as you consider whether to get your own personal video report.
        </Typography>
      </div>

      <div>
        <div className={classes.containerButton}>
          <LoadingButton fullWidth onClick={handleStartProductDemo} variant="contained" color="primary">
            Start Product Demo
          </LoadingButton>
        </div>
      </div>
    </Container>
  );
};
